import type * as yup from 'yup';

import { kradSchema } from '@/features/Sparten/krad/schema/schema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const inputSchema = kradSchema;

export type InputStore = yup.Asserts<typeof inputSchema>;

export const useKradInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'KradInputStore',
);
